import React from "react";
import PersonalCounsellingbanner from "../../AVHRBanner/PersonalCounsellingNB.png";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  FaQuestionCircle,
  FaBookOpen,
  FaHeartBroken,
  FaHandsHelping,
  FaHeartbeat,
  FaBullseye,
} from "react-icons/fa";

function PersonalCounselling() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={PersonalCounsellingbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour-B">
              <p className="edu-support-text uppercase">Our Edu Support</p>

              <h1 className="career-library-heading">Personal Counselling</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}>
            <h1 className="mb-2 avhrProject-h1">
              Personalized Guidance for Life & Career
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{fontSize: "20px"}}>
              Get expert advice to overcome personal, academic, and professional
              challenges with clarity and confidence
            </p>
          </div>
        </div>

        <div
          className="py-10 px-4 sm:px-6 lg:px-20 carrerbackgroundcolour pt-2"
          style={{ backgroundColor: "#FFF2EB" }}>
          <h2 className="text-2xl md:text-3xl text-center mb-4 avhrProject-h2">
            Areas We Cover
          </h2>

          <div className="grid">
            <div className="col-12 grid">
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaQuestionCircle className="circelcolour text-5xl mt-4" /> */}
                 <span className="text-5xl mt-4">❓</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Career Confusion
                  </h3>
                  <p className="avhrProject-p">
                    Get clarity on your career direction with expert evaluation
                    of your interests and options
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaBookOpen className="circelcolour text-5xl mt-4" /> */}
                   <span className="text-5xl mt-4">📚</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Academic Stress</h3>
                  <p className="avhrProject-p">
                    Manage exam anxiety, workload pressure, and academic
                    expectations effectively
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaHeartBroken className="circelcolour text-5xl mt-4" /> */}
                 <span className="text-5xl mt-4">💔</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Relationship Issues</h3>
                  <p className="avhrProject-p">
                    Navigate personal and family relationships with improved communication and emotional balance 
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaHandsHelping className="circelcolour text-5xl mt-4" /> */}
                 <span className="text-5xl mt-4">🧘‍♂️</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">Life Coaching</h3>
                  <p className="avhrProject-p">
                    Set personal goals and develop positive habits for overall
                    growth and well-being
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaHeartbeat className="circelcolour text-5xl mt-4" /> */}
                 <span className="text-5xl mt-4">😌</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3">
                    Anxiety & Stress Management{" "}
                  </h3>
                  <p className="avhrProject-p">
                    Learn coping strategies to reduce anxiety and maintain
                    emotional stability
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaBullseye className="circelcolour text-5xl mt-4" /> */}
                 <span className="text-5xl mt-4">🎯</span>
                <div>
                  <h3 className=" mb-2 avhrProject-h3 ">
                    Goal Setting & Motivation
                  </h3>
                  <p className="avhrProject-p">
                    Stay focused and driven by setting clear, achievable
                    personal and professional goals
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background:
                "linear-gradient(TO RIGHT, #D66900, #E8B03F, #FCED0A)",
            }}>
            <p className="mb-2 text-center avhrProject-p ">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              Don't let challenges hold you back. Get the personal guidance you
              need to overcome obstacles and move forward with confidence
              <br />
              Schedule your session now
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default PersonalCounselling;
